import React from 'react';
import Container from 'react-bootstrap/esm/Container';

import { CancelReasonTable } from '../Component/CancelReasons/CancelReasonTable';
export const CancelReasonsPage = () => {
  return (
    <Container style={{ marginTop: '50px' }}>
      <CancelReasonTable />
    </Container>
  );
};
